import { MiniZillow } from '../../../assets/mini-zillow'

const ReviewCardSkeleton = () => {
  return (
    <div className="flex flex-col gap-[10px] border-t py-8">
      <div className="mb-[10px] flex items-center gap-2">
        <div className="size-[60px] animate-pulse rounded-full bg-gray-200" />
        <div className="flex flex-col gap-1">
          <div className="h-5 w-32 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <MiniZillow size={15} />
        <div className="flex items-center gap-1">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="size-4 animate-pulse rounded bg-gray-200" />
          ))}
        </div>
      </div>
      <div className="space-y-2">
        <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  )
}

export default ReviewCardSkeleton
